module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/braveshop_bravenet_website.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/braveshop_bravenet_website.png
// module id = oEvI
// module chunks = 0